module.exports = __webpack_public_path__ + "static/media/texpresion.29be8c5b.jpg";